import React from 'react';

import { SideBarModal } from '@/components';
import { Button } from '@/design-system/button';

import { fmtDateTime } from '../format';
import type { WarehouseSku } from '../types';
import { SkuSections } from './SkuModals';
import { codeCls, metaCls } from './ui';

/** Right-side detail of one SKU: the master in its groups + Edit. */
export const SkuDetailPanel: React.FC<{
  sku: WarehouseSku | null;
  onClose: () => void;
  onEdit: (sku: WarehouseSku) => void;
}> = ({ sku, onClose, onEdit }) => {
  if (!sku) return null;
  return (
    <SideBarModal
      isOpen
      onClose={onClose}
      position="right"
      width="lg"
      header={
        <div className="min-w-0" data-testid="sku-detail">
          <p className={codeCls}>{sku.sku}</p>
          <h2 className="truncate text-base font-semibold tracking-tight text-text-strong-950">
            {sku.itemName}
          </h2>
          <p className={metaCls}>
            Dibuat {fmtDateTime(sku.createdAt)}
            {sku.updatedAt && sku.updatedAt !== sku.createdAt
              ? ` · diubah ${fmtDateTime(sku.updatedAt)}`
              : ''}
          </p>
        </div>
      }
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button tone="neutral" style="stroke" onClick={onClose}>
            Tutup
          </Button>
          <Button
            onClick={() => onEdit(sku)}
            leftIcon={<i className="ri-edit-line text-[14px]" />}
            data-testid="sku-detail-edit"
          >
            Edit SKU
          </Button>
        </div>
      }
    >
      <div className="px-5 py-4">
        <SkuSections
          sku={sku}
          client={sku.client?.name ?? `Client #${sku.clientID}`}
        />
      </div>
    </SideBarModal>
  );
};
